import { useAuth } from './use-auth';
import { AdminRoles } from '@/lib/types';

export default function useCanManageContentTypes() {
  const auth = useAuth();
  return auth.role?.id === AdminRoles.WorkspaceAdmin;
}
